import { ProjectDetailLayout } from "@mnk/frontend/components/pages/projects/detail/layout";
import { trpc } from "@mnk/frontend/lib/trpc";
import { NotFound } from "@mnk/frontend/pages/NotFound";
import { useParams } from "react-router-dom";

export const ProjectDetail = () => {
  const { id } = useParams<{ id: string }>();
  const getProject = trpc.getProjectByItemId.useQuery({ itemId: id ?? "" });
  const getOffice = trpc.getOfficeByItemId.useQuery({ itemId: id ?? "" });

  if (!id || !getProject.data) {
    return <NotFound />;
  }

  if (!getOffice.data) {
    return <NotFound />;
  }

  return <ProjectDetailLayout projectId={getProject.data.id} officeName={getOffice.data.name} />;
};
